import { NavLink } from 'react-router'
import './aside.scss'
import SpriteSvg from '../SpriteSvg'
import { useAuth } from 'src/utils/Hooks/useAuth'
import DashboardIcon from '../Icons/DashboardIcon'
import ClientsIcon from '../Icons/ClientsIcon'
// import OptimizerIcon from '../Icons/OptimizeIcon'
import SurveyIcon from '../Icons/SurveyIcon'
import GitIcon from '../Icons/GitIcon'
// import BugTrackerIcon from '../Icons/BugTrackerIcon'
import { memo } from 'react'
import FolderIcon from '../Icons/Folder'
import HomeWebIcon from '../Icons/HomeWeb'

const menu = [
  {
    title: 'Dashboard',
    icon: DashboardIcon,
    link: '/'
  },
  {
    title: 'CLients',
    icon: ClientsIcon,
    link: '/clients'
  },
  // {
  //   title: 'Optimizer',
  //   icon: OptimizerIcon,
  //   link: '/optimize'
  // },
  {
    title: 'Survey',
    icon: SurveyIcon,
    link: '/surveys'
  },
  {
    title: 'Git',
    icon: GitIcon,
    link: '/github'
  },
  // {
  //   title: 'Bug Tracker',
  //   icon: BugTrackerIcon,
  //   link: '/bug-tracker'
  // },
  {
    title: 'WebAdmin',
    icon: HomeWebIcon,
    link: '/site-admin'
  },
  {
    title: 'Media',
    icon: FolderIcon,
    link: '/media'
  }
]

const Aside = () => {
  const { role } = useAuth()
  return (
    <aside>
      <div className="logo">
        <NavLink to="/">
          <SpriteSvg id="logo_cart" />
        </NavLink>
      </div>
      <ul>
        {menu.map((item, index) => {
          if (role === 'ADMIN') {
            return (
              <li key={index}>
                <NavLink to={item.link}>
                  <item.icon />
                </NavLink>
              </li>
            )
          } else if (item.title !== 'Admin' && item.title !== 'Users Control') {
            return (
              <li key={index} title={item.title}>
                <NavLink to={item.link}>
                  <item.icon />
                </NavLink>
              </li>
            )
          }
        })}
      </ul>
    </aside>
  )
}

export default memo(Aside)
